import { render, staticRenderFns } from "./ItemListGruppoDistinteConsumi.vue?vue&type=template&id=0a9c6e8e&scoped=true"
import script from "./ItemListGruppoDistinteConsumi.vue?vue&type=script&lang=ts"
export * from "./ItemListGruppoDistinteConsumi.vue?vue&type=script&lang=ts"
import style0 from "./ItemListGruppoDistinteConsumi.vue?vue&type=style&index=0&id=0a9c6e8e&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c6e8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9c6e8e')) {
      api.createRecord('0a9c6e8e', component.options)
    } else {
      api.reload('0a9c6e8e', component.options)
    }
    module.hot.accept("./ItemListGruppoDistinteConsumi.vue?vue&type=template&id=0a9c6e8e&scoped=true", function () {
      api.rerender('0a9c6e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListGruppoDistinteConsumi.vue"
export default component.exports